<div class="small-layout-container" [class.rtl-layout]="isRtl">
    
    <top-nav-small></top-nav-small>

    <!-- Scrollable Content -->
    <ng-content class="content" select="[page-content]" #contentWrapper></ng-content>
        
    <!-- Custom Chip List Overlay (outside the stack) -->
    @if (showParticipantList && hasMultipleParticipants) {
        <div class="chip-list-backdrop" (click)="closeParticipantList()"></div>
        <div class="chip-list-popup" [@slideUp]>
            @for (event of currentEvents; track event.id; let i = $index) {
                <mat-chip class="popup-chip" [style.animation-delay.ms]="i * 50" (click)="openOngoingEventDialog(event)">
                    <mat-icon matChipAvatar>person</mat-icon>
                    <span>
                        {{ event.candidateName }}
                    </span>
                </mat-chip>
            }
        </div>
    }

    <!-- Bottom Fixed Stack Container -->
    <div class="bottom-stack-container" [class.nav-hidden]="smallNavService.hideBottomNavigation()" [class.bulk-mode-active]="isBulkModeActive" [style.--bulk-panel-height]="bulkPanelHeightPx">
        <!-- Floating Action Buttons (right side) -->
        <div class="floating-actions-column">
            @if (isCalendarRoute) {
                <app-calendar-date-buttons></app-calendar-date-buttons>
            }
            <page-action></page-action>
        </div>

        <!-- Participant Chip (left side) -->
        @if (!smallNavService.hideBottomNavigation() && showChip && !isBulkModeActive && !isMultiSelectActive) {
            <div class="participant-chip-container">
                <mat-chip-set>
                    @if (showParticipantList) {
                        <mat-chip 
                            (click)="toggleParticipantList()"
                            class="participant-chip">
                                X
                        </mat-chip>
                    } @else {
                        <mat-chip 
                            (click)="handleOngoingEventClick()"
                            class="participant-chip on-going-chip">
                            <mat-icon matChipAvatar>person</mat-icon>
                            {{ chipLabel }}
                        </mat-chip>
                    }
                </mat-chip-set>
            </div>
        }

        <!-- Bottom Navigation -->
        @if (!smallNavService.hideBottomNavigation() && !isBulkModeActive) {
            <app-bottom-navbar [class.hidden]="hideNav"></app-bottom-navbar>
        }
    </div>

    <!-- Spacer for content scrolling -->
    @if (!smallNavService.hideBottomNavigation() && !isBulkModeActive) {
        <div class="extra-bottom-space-with-nav"></div>
    } @else {
        <div class="extra-bottom-space" [class.bulk-mode-active]="isBulkModeActive" [style.--bulk-panel-height]="bulkPanelHeightPx"></div>
    }
</div>
